import { useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { getSelectedLabels, mergePDFSFromUrls } from "../../utils/labelService";

const DownloadSelectedLabels = ({
  user,
  selectedPrintLabels,
  setErrorOnRetrieveData,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      const labelUrls = await getSelectedLabels(selectedPrintLabels, user);

      if (labelUrls && labelUrls.length > 0) {
        const mergedPdfBlob = await mergePDFSFromUrls(labelUrls);
        const mergedUrls = URL.createObjectURL(mergedPdfBlob);
        window.open(mergedUrls, "_blank");
      } else {
        if (setErrorOnRetrieveData)
          setErrorOnRetrieveData("No hay etiquetas para descargar.");
      }
    } catch (error) {
      console.error(`Error al descargar las etiquetas: ${error}`);
      if (setErrorOnRetrieveData)
        setErrorOnRetrieveData("No hay etiquetas para descargar.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid item md={2.6} xs={6}>
      <div>
        <Button
          type="submit"
          variant="outlined"
          onClick={handleDownload}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {isLoading ? (
            "Cargando..."
          ) : (
            <>
              <DownloadIcon fontSize="small" /> Descargar seleccionadas
            </>
          )}
        </Button>
      </div>
    </Grid>
  );
};

export default DownloadSelectedLabels;
